import { MrbBaseListViewStore } from "mrb/core";
import { MrbTableViewStore } from "mrb/components";
import { mrbDefaultFormats } from "mrb/common/formatting";

class StationListViewStore extends MrbBaseListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            layoutActions: {
                create: {
                    onClick: () => this.rootStore.routerStore.goTo("master.administration.station.create"),
                    label: "ADMINISTRATION.STATION.LIST.BUTTONS.ADD",
                },
            },
            queryConfig: {
                orderBy: "title",
                orderDirection: "asc",
            },
        });
        this.routeStore = routeStore;

        this.setGridStore(
            new MrbTableViewStore(this.rootStore, this.queryUtility, {
                onRowClick: (node) =>
                    this.rootStore.routerStore.goTo("master.administration.station.preview", { id: node.data.id }),
                columns: [
                    {
                        key: "title",
                        title: "ADMINISTRATION.STATION.LIST.COLUMNS.TITLE",
                        sortable: true,
                    },
                    {
                        key: "isActive",
                        title: "ADMINISTRATION.STATION.LIST.COLUMNS.STATUS",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Active",
                            falseLabel: "Inactive",
                        },
                    },
                    {
                        key: "isPremium",
                        title: "ADMINISTRATION.STATION.LIST.COLUMNS.PREMIUM",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Premium",
                            falseLabel: "Free",
                        },
                    },
                    {
                        key: "isTurnedOnByDefault",
                        title: "ADMINISTRATION.STATION.LIST.COLUMNS.DEFAULT",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Enabled",
                            falseLabel: "Disabled",
                        },
                    },
                    {
                        key: "isVisible",
                        title: "ADMINISTRATION.STATION.LIST.COLUMNS.VISIBLE_ON_PORTAL",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Visible",
                            falseLabel: "Hidden",
                        },
                    },
                ],
                actions: {
                    edit: {
                        onClick: (item) =>
                            this.rootStore.routerStore.goTo("master.administration.station.edit", { id: item.id }),
                        label: "ADMINISTRATION.STATION.LIST.ACTIONS.EDIT",
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost u-mar--right--tny",
                        },
                    },
                    delete: {
                        onClick: (item) =>
                            this.rootStore.confirmDialogStore.showConfirm({
                                message: "Do you want to delete station?",
                                onConfirm: async () => {
                                    try {
                                        await this.routeStore.deleteStation(item);
                                        this.queryUtility.fetch();
                                    } catch (err) {
                                        this.rootStore.notificationStore.error(
                                            "An unexpected error occurred. Unable to delete station.",
                                            err
                                        );
                                    }
                                },
                                yesLabel: "Delete",
                                noLabel: "Cancel",
                                description: "You won't be able to revert this action.",
                            }),
                        label: "ADMINISTRATION.STATION.LIST.ACTIONS.DELETE",
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost",
                        },
                    },
                },
            })
        );
    }

    find(params) {
        return this.routeStore.findStations(params);
    }

    onFetchError() {
        this.rootStore.notificationStore.error(
            "An unexpected error occurred while trying to load data. Please contact the support team."
        );
    }
}

export default StationListViewStore;
